export const tabsActionsSlotSx = {
  ml: 'auto',
  maxWidth: '100%',
  justifyContent: 'flex-end',
  '& .MuiCard-root': {
    p: 0,
  },
  '& .MuiIconButton-sizeSmall': {
    width: 28,
    height: 28,
    p: 0.5,
  },
  '& .MuiIconButton-sizeSmall .MuiSvgIcon-root': {
    fontSize: 20,
  },
};

export const tabBadgeSx = {
  ml: 0.5,
  '& .MuiBadge-badge': {
    position: 'static',
    transform: 'translateY(-1px)',
    minWidth: 16,
    height: 16,
    p: 0,
    fontSize: 10,
  },
};

export const tabsSx = {
  minHeight: 'auto',
  p: 0,
  maxWidth: '100%',
  '& .MuiTabs-scroller': {
    minWidth: 0,
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
};

export const tabSx = {
  minWidth: 'auto',
  minHeight: 'auto',
  p: 0,
  pb: 0.5,
  mr: 3,
  borderBottom: '1px solid transparent',
  '&.Mui-selected': {
    borderColor: 'brand',
  },
};
